import { render, staticRenderFns } from "./SaqQuestion.vue?vue&type=template&id=6ce92079&scoped=true"
import script from "./SaqQuestion.vue?vue&type=script&lang=js"
export * from "./SaqQuestion.vue?vue&type=script&lang=js"
import style0 from "./SaqQuestion.vue?vue&type=style&index=0&id=6ce92079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce92079",
  null
  
)

export default component.exports